import { render } from "./examSelect.vue?vue&type=template&id=7907b23c&scoped=true"
import script from "./examSelect.vue?vue&type=script&lang=js"
export * from "./examSelect.vue?vue&type=script&lang=js"

import "./examSelect.vue?vue&type=style&index=0&id=7907b23c&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7907b23c"]])

export default __exports__